import {
    GESTION_OPERATIVA_GET_PERITAJE,
    GESTION_OPERATIVA_GET_PERITAJE_DISMISS_ERROR,
  } from '../constants'
  
  export function getPeritaje(patente, verPeritaje, usados, isCurrent = null, status = null) {
    return (dispatch,getState) => {
      const {gestionOperativa} = getState()
      if(gestionOperativa.isValidLicensePlate){
        dispatch({
          type: GESTION_OPERATIVA_GET_PERITAJE,
          data: {patente, verPeritaje, usados, isCurrent , status}
        })
      }
    }
  }

  export function dismissGetPeritajeError() {
    return {
      type: GESTION_OPERATIVA_GET_PERITAJE_DISMISS_ERROR,
    }
  }
